<div id="progress-navigation">
  <div class="container" [(ngModel)]="currentProgress.id" ngDefaultControl>
    @for (_progress of getProgressList(); track trackById(i, _progress); let i = $index; let last = $last) {
      <span class="step"
        [ngClass]="_progress.id === currentProgress.id ? 'current' : ''">
        <span class="step_content">
          <span class="number">{{ i + 1 }}</span>
          <span class="description">. {{ _progress.title }}</span>
        </span>
      </span>
    }
  </div>
</div>
